"use client";

import type { FC } from "react";
import { Modal, type ModalProps } from "@huub-web/ui";

import type { AnalysisObservationCategory } from "../../../types";
import { containerStyle } from "./AnalysisObservationsModal.css";
import type { AnalysisSectionIndex } from "../../Analysis/types/AnalysisSections";
import { AnalysisObservationsModalContent } from "./AnalysisObservationsModalContent";

export type AnalysisObservationsModalProps = ModalProps & {
  category: AnalysisObservationCategory;
  index: AnalysisSectionIndex;
};

export const AnalysisObservationsModal: FC<AnalysisObservationsModalProps> = ({
  category,
  index,
  escape: escapable = true,
  closeable = false,
  size = "auto",
  variant = "tint",
  onClose,
  ...props
}) => (
  <Modal
    escape={escapable}
    closeable={closeable}
    size={size}
    variant={variant}
    className={containerStyle}
    padding="none"
    onClose={onClose}
    {...props}
  >
    <AnalysisObservationsModalContent
      category={category}
      index={index}
      onClose={onClose}
    />
  </Modal>
);
